import MaterialTab, { TabProps as TabProps } from '@mui/material/Tab';

export function Tab(props: TabProps) {
    return <MaterialTab data-testid={'Tab-container'} {...props} />;
}

export default Tab;
